import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IReclassificationStatus, IGetReclassParams, IReclassification } from './reclassification.model';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { LoggingService } from '@services/logging.service';

@Injectable({
  providedIn: 'root',
})
export class ReclassificationService {
  constructor(private http: HttpClient, private logger: LoggingService) {}

  public get(params: IGetReclassParams): Observable<IReclassification> {
    return this.http.post(`/api/FinancialReview/FinancialReviewReclassification/`, params).pipe(
      catchError((er) => {
        this.logger.httpError(this.constructor.name, 'FinancialReviewReclassification', er);
        return throwError(er);
      })
    ) as Observable<IReclassification>;
  }

  public post(reclassification: IReclassification) {
    return this.http.post(`/api/FinancialReview/SaveFinancialReviewReclassification/`, reclassification).pipe(
      catchError((er) => {
        this.logger.httpError(this.constructor.name, 'SaveFinancialReviewReclassification', er);
        return throwError(er);
      })
    );
  }

  public getFinancialReviewReclassificationStatus(searchStrategyId: number, comparableId: number): Observable<IReclassificationStatus[]> {
    return this.http.get<IReclassificationStatus[]>(`/api/FinancialReview/GetComparableReclassificationStatus/${searchStrategyId}/${comparableId}`);
  }
}
